export const SubHeading = (props: { children: React.ReactNode }) => {
  return <h4 className="font-bold my-4">{props.children}</h4>;
};
